/**
* [Ref] - Denotes Pseudo Code Reference  
*  
* This component is the Non Catalog request page component. The component displays the Non Catalog request page details.
* 
* App Name: SDI-Walmart
* Author: Chandrasekar
* Created Date: 08/11/2020 
*/
import React, { Component } from 'react';
/**
 * Ref: Src_PC_02
 * Importing the action and store file and set to an object.
 */
import * as SrcNonCatalogAction from '../actions/SrcNonCatalogAction';
import SrcNonCatalogStore from '../stores/SrcNonCatalogStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import SearchResultsStore from '../stores/SearchResultsStore';
import { withTranslation, Trans } from 'react-i18next'
import swal from 'sweetalert';
import i18n from '../i18n';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Autocomplete from 'react-autocomplete'
let qckKeycounter = 0;
let type = 0;
let rmvAttachindex = -1;
let currentPagePath;
let Session_ZEUSNOCATALOGSITE;
let MFGSearchValue = "";
let cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
const queryParams = new URLSearchParams(window.location.search)
class NonCatalogComponent extends Component {
    /**
    * Ref: NC_PC_04
    * Define the constructor that takes props as parameter
    * 
    * @param props
    */
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.saveNonCatalog = this.saveNonCatalog.bind(this);
        this.clearFormValues = this.clearFormValues.bind(this);
        this.handleAttachment = this.handleAttachment.bind(this);
        this.loadAttachments = this.loadAttachments.bind(this);
        this.downloadAttachment = this.downloadAttachment.bind(this);
        this.bindAttachments = this.bindAttachments.bind(this);
        this.removeAttachmentResponse = this.removeAttachmentResponse.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.handleQuantity = this.handleQuantity.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        const queryparam = new URLSearchParams(window.location.search)
        const orgin = queryparam.get('Orgin')
        /**
       * Ref: NC_PC_05
       * Set the initial values of the state variables
       */
        this.state = {
            mfgPartNumber: "",
            mfgName: "",
            recommendedSupplier: "",
            supplierPrtNbr: "",
            description: "",
            quantity: "",
            uom: "",
            unitOfMeasureData: [],
            attachmentPathArr: [],
            isInvalid: false,
            txtItemID: "",
            quickItemVisible: false,
            strCplusitemid: "0",
            attachmentErrormsg: "",
            isFavorited: false,
            Page_ID: "",
            islblInfo1Visible: false,
            isCheckCatalog: false,
            isbuttonclick: false,
            newtest: queryParams,
            SupplierDD: [],
            SupplierValue: "",
            DeliveryDate: "",
            EstPrice: "",
            CatYes: false,
            CatNo: true,
            MFGSuggestions: [],
            MFGAllSuggestions: [],
            ExtPrice: 0,
            qtyErrorMsg: "",
            unitPriceErrorMsg: "",
            cartConfirmationPopupTxt: "" //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        }
        cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    };
    /**
   * Ref: NC_PC_06
   * componentwillMount method will be first method which will be invoked
   * when Non Catalog page is loaded
   */
    componentDidMount() {
        window.scrollTo(0, 0)
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        console.log("hasReqApprovalCheck", CookieService.getLocalStorageValues("hasReqApprovalCheck"));
        $("#quickItemSuccess").hide();
        $(`#nonCatalogSaveSuccess`).hide();
        $(`#SuccessPopUp`).hide();
        Session_ZEUSNOCATALOGSITE = CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE");
        let nonCatalogBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            IsSrcNonCatalog: true,
        }
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        /**
        * Ref: NC_PC_08
        * Invoke the action to get the page load data from API.
        */
        SrcNonCatalogAction.getUnitOfMeasures(nonCatalogBO);
        /**
        * Invoke the action to check the current page is favorited
        */
        SrcNonCatalogAction.getCurrentFavPage(getFavPageBO);
        /*
         * Ref: NC_PC_07
         * Define the listener methods
         */
        SrcNonCatalogStore.on('GetMfgNameSuggResponse', this.GetMfgNameSuggResponse);
        SrcNonCatalogStore.on('load', this.loadUnitOfMeasures);
        SrcNonCatalogStore.on('save', this.saveSuccess);
        SrcNonCatalogStore.on('attachmentResponse', this.loadAttachments);
        SrcNonCatalogStore.on('Src_rmvAttach', this.removeAttachmentResponse);
        /*
         * Favorite page response listeners
         */
        SrcNonCatalogStore.on('favpage', this.loadFavPageResponse);
        SrcNonCatalogStore.on('updateFavPage', this.updateFavPageResponse);
    }
    componentWillUnmount() {
        SrcNonCatalogStore.removeListener('GetMfgNameSuggResponse', this.GetMfgNameSuggResponse);
        SrcNonCatalogStore.removeListener('load', this.loadUnitOfMeasures);
        SrcNonCatalogStore.removeListener('save', this.saveSuccess);
        SrcNonCatalogStore.removeListener('attachmentResponse', this.loadAttachments);
        SrcNonCatalogStore.removeListener('Src_rmvAttach', this.removeAttachmentResponse);
        SrcNonCatalogStore.removeListener('favpage', this.loadFavPageResponse);
        SrcNonCatalogStore.removeListener('updateFavPage', this.updateFavPageResponse);
    }
    /*
     * Listener method for the response of Save/Delete favorite page
     */
    updateFavPageResponse = () => {

        if (SrcNonCatalogStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(SrcNonCatalogStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(SrcNonCatalogStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };
    /*
     * Handle change method for favorite page checkbox
     */
    handleFavorite = (event) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ isFavorited: event.target.checked });
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Sourced Non-Catalog Entry",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            SrcNonCatalogAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            SrcNonCatalogAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /*
     * Listener method for loading favorite page icon
     */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(SrcNonCatalogStore.currentFavPageResponse);
        console.log("favPageResponse", favPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    /*
     * Common method to refresh the master data in menu
     */
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true,//isFirstTimeLoaded
            HOME_STORE: CookieService.getLocalStorageValues("HOME_STORE"), //CPW-167_PC_
        };
        MenuAction.getMasterData(masterBO);
    };
    /**
    * Closepopup method for closing Quick item popup
    * @param message
    */
    closePopup = (message) => {
        $('#quickconfirm').modal('hide');
        this.setState({ strCplusitemid: "0" });
        console.log("Hit", message);
        if (message == 1) {
            $("#quickItemSuccess").show();
            $(`#nonCatalogSaveSuccess`).hide();
            //  alert(`Item ${this.state.txtItemID} has been added to cart`);
            this.refreshMenu();
        } else if (message == 2) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Invalid data is entered for Quick Item Entry"
            });
            //  alert("Invalid data is entered for Quick Item Entry");
        };
    };
    getItemValue(item) {

        return `${item.value}`;
    }
    renderItem(item, isHighlighted) {

        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }
    onSelectItem = (event) => {

        this.setState({
            mfgName: event
        });

    }
    /*
     * Ref: NC_PC_13
     * Listener method of remove attachment response
     */
    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = SrcNonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments.splice(rmvAttachindex, 1);
            //WW-981 To handle the attachment error message after file removal - Deepthi N H
            let errorMsgAttach = "";
            if (tempAttachments.length > 0) {
                let attachmentStr = tempAttachments.map(e => e.FilePath).join("|");
                if (attachmentStr.length > 254) {
                    errorMsgAttach = "You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names."
                }

            }
            this.setState({ attachmentPathArr: tempAttachments, attachmentErrormsg: errorMsgAttach });
            rmvAttachindex = -1;
        }
    };
    /*
     * Ref: NC_PC_17
     * Listener method of loading attachments
     */
    loadAttachments = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = SrcNonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(SrcNonCatalogStore.attachmentResponse);
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    //WW-981 To attach the same file after removing the attached file - Deepthi N H
    handleFileOnClick = (event) => {
        event.target.value = '';
    }
    /** 
    * Ref: NC_PC_10
    * Handle method for attachments on change
    * @param event
    */
    handleAttachment = (event) => {

        let files = event.target.files;
        //WW-311 Non - Catalog Attachments should allow attachments of type pdf or Img - Deepthi
        let filetype = files[0].type;
        if (!(filetype.toLowerCase().includes('jpg') || (filetype.toLowerCase().includes('png')) || (filetype.toLowerCase().includes('message/rfc822')) || (files[0].name.toLowerCase().includes('.msg')) || (filetype.toLowerCase().includes('jpeg')) || (filetype.toLowerCase().includes('pdf')))) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "You can choose only the Image, PDF and Email files!!"
            });
            //alert("You can choose only the Image and PDF files!!");
            return;
        }
        console.log("event", files);
        //WW-981 Source Non Catalog Changes - Deepthi N H
        //PC_WW_1084_01 Vishwa S
        //let fileSize = files[0].size;
        //let SizeinKB = fileSize / 1024;
        //let SizeinMB = SizeinKB / 1000;
        //if (SizeinMB > 3) {
        //    this.setState({ attachmentErrormsg: "Selected file size is greater than 3MB, please attach files less than 3MB" });
        //    return false;
        //}
        if (files.length > 0) {
            this.setState({ attachmentErrormsg: "" });
            if (this.state.attachmentPathArr.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    let fileSize = files[i].size;
                    let SizeinKB = fileSize / 1024;
                    let SizeinMB = SizeinKB / 1000;
                    let isDuplicate = this.state.attachmentPathArr.filter((attach) => attach.FileName == files[i].name).length > 0 ? true : false;
                    if (isDuplicate) {
                        this.setState({ attachmentErrormsg: "Selected file is already attached, please try again" });
                        return false;
                    }
                }
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            SrcNonCatalogAction.addAttachment(files);
        }

    };
    /**
    * Ref: NC_PC_12
    * Listener method of downloading attachments
    * @param e
    * @param attachment
    */
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SrcNonCatalogAction.downloadAttachment(downloadBO);
    };
    /**
     * Ref: NC_PC_13
     * On click method of removing attachments
     * @param filepath
     * @param index
     */
    removeAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SrcNonCatalogAction.removeAttachment(removeBO);
    }
    /**
    * Binding attachments using map function
    */
    bindAttachments = () => {
        return this.state.attachmentPathArr.map((attachment, index) => {
            return (
                <span className="custom-path-preview py-2 px-3 mr-2 mb-2 text-nowrap" key={index}>
                    <span className="font-12 font-regular mr-2" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName.length > 30 ? attachment.FileName.substring(0, 30) + `...` : attachment.FileName}</span>
                    <span>
                        <img className="cursor-pointer" src="images/file-close-icon.svg" alt="close-icon" onClick={() => this.removeAttachments(attachment.FilePath, index)} />
                    </span>
                </span>
            );
        });
    };
    /**
    * Reusable method to clear form values
    */
    clearFormValues = () => {
        $("#quickItemSuccess").hide();
        $(`#nonCatalogSaveSuccess`).hide();
        ;
        let test = JSON.parse(localStorage.getItem("SDIFavItems"))
        console.log("FavItem_Cat_SubCat", test)
        // alert("onblur button click")
        // $(this).off("blur")
        //  event.stopPropagation()
        let uomDefaultValue = this.state.unitOfMeasureData.filter((item) => item.UNIT_OF_MEASURE == "EA").length > 0 ? "EA" : "";
        this.setState({
            mfgPartNumber: "",
            mfgName: "",
            recommendedSupplier: "",
            supplierPrtNbr: "",
            description: "",
            quantity: "",
            uom: uomDefaultValue,
            attachmentPathArr: [],
            txtItemID: "",
            strCplusitemid: "0",
            attachmentErrormsg: "",
            //5755 - Update a state of error message as empty.
            qtyErrorMsg: "",
            unitPriceErrorMsg: "",
            isInvalid: false,
            isbuttonclick: true,
            SupplierValue: "",
            DeliveryDate: "",
            EstPrice: "",
            CatNo: true,
            CatYes: false,
            ExtPrice: 0
        });
    };
    /**
     * Ref:NC_PC_18
     * Listener method after saving non catalog request to cart
     */
    saveSuccess = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let saveResponse = JSON.parse(SrcNonCatalogStore.saveResponse);
        console.log("saveResponse", saveResponse);
        if (type == 1) {
            this.clearFormValues();
            ;
            //$(`#SuccessPopUp`).show();
            $('#SuccessPopUp').modal('show');
        } else {
            this.props.history.push({
                pathname: "/shoppingcart",
            });
        }
    };
    GetMfgNameSuggResponse = () => {
        let MfgNameSuggResponse = JSON.parse(SrcNonCatalogStore.GetMfgNameSuggResponse);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let locMFGValue = [];
        if (MfgNameSuggResponse != undefined && MfgNameSuggResponse != null) {
            MfgNameSuggResponse.forEach((val, index) => {
                let locobj = {
                    value: val.MFG_ID,
                    label: val.MFG_ID
                }
                locMFGValue.push(locobj);
            })
            this.setState({ MFGSuggestions: locMFGValue, MFGAllSuggestions: locMFGValue, mfgName: MFGSearchValue });
        }
        else {
            this.setState({ mfgName: MFGSearchValue });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Oops! Something went wrong"
            });
        }
    }
    /**
    * Ref:NC_PC_15
    * Listener method for loading unit of measures data
    */
    loadUnitOfMeasures = () => {
        let pageLoadResponse = JSON.parse(SrcNonCatalogStore.pageLoadData);

        console.log("pageLoadResponse", pageLoadResponse);
        if (pageLoadResponse.FlagData.length > 0) {
            let islblInfo1VisibleRes = pageLoadResponse.FlagData[0].islblInfo1Visible.toLowerCase() == `true`;
            this.setState({ islblInfo1Visible: islblInfo1VisibleRes });
        }

        if (pageLoadResponse.Data) {
            var obj = {};
            for (var i = 0, len = pageLoadResponse.Data.length; i < len; i++)
                obj[pageLoadResponse.Data[i]['DESCR']] = pageLoadResponse.Data[i];

            pageLoadResponse.Data = new Array();
            for (var key in obj)
                pageLoadResponse.Data.push(obj[key]);
            let uomDefaultValue = pageLoadResponse.Data.filter((item) => item.UNIT_OF_MEASURE == "EA").length > 0 ? "EA" : "";
            this.setState({ unitOfMeasureData: pageLoadResponse.Data, uom: uomDefaultValue, SupplierData: pageLoadResponse.SupplierList });
            this.buildSupplierDD()
        }
    };
    buildSupplierDD = () => {
        ;
        //WW-1069 Only Catalog suppliers are shown in Sourced Non-Catalog Panel, need to show both catalog and non catalog supplier - Deepthi N H
        let SupplierData = this.state.SupplierData;
        let locSupplierData = [];
        if (SupplierData != undefined) {
            if (SupplierData.length > 0) {
                SupplierData = SupplierData.sort((a, b) => (a.NAME1 > b.NAME1) ? 1 : -1);
                SupplierData.forEach((val, ind) => {
                    if (ind == 0) {
                        let obj = {
                            value: "0",
                            label: "Select Supplier"
                        }
                        locSupplierData.push(obj);
                    }
                    let obj = {
                        value: val.VENDOR_ID,
                        label: val.NAME1
                    }
                    locSupplierData.push(obj);
                });
            }
        }
        this.setState({ SupplierDD: locSupplierData });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    bindSupplierDropdown = () => {
        ;
        return this.state.SupplierDD.map((val, index) => {
            return (<option key={index} value={val.value}>{val.label}</option>)
        });
    };
    /**
     * Ref:NC_PC_20
     * Bind method for UOM dropdown
     */
    bindUOMDropdown = () => {
        return this.state.unitOfMeasureData.map((uom, index) => {
            return (<option key={index} value={uom.UNIT_OF_MEASURE}>{uom.DESCR}</option>)
        });
    };
    /**
     * Handle method for quantity textbox
     */
    handleQuantity = (e) => {
        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value === '') {
                this.setState({ quantity: e.target.value, ExtPrice: 0, qtyErrorMsg: "" });
            }
            else {
                //WW-981 To calculate Ext price - Deepthi N H
                let locExtPrice;
                if (this.state.EstPrice != null && this.state.EstPrice != undefined) {
                    locExtPrice = this.state.EstPrice * parseInt(e.target.value);
                    locExtPrice = parseFloat(locExtPrice.toFixed(2))
                }
                this.setState({ quantity: e.target.value, ExtPrice: locExtPrice, qtyErrorMsg: "" });
            }

        }

    }
    handledate = (date) => {
        return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
    }
    onChangeText = (type, e) => {

        if (type == "Date") {
            //let validDate = this.handledate(e);
            this.setState({
                DeliveryDate: e
            });
            //this.setState({ DeliveryDate: validDate });
            // console.error("DeepthiDelDate", this.state.DeliveryDate);
        }
        else if (type == "Price") {
            let PriceVal = e.target.value;
            let Precision;
            let dotCnt = PriceVal.split(".").length - 1;
            if (dotCnt < 2) {
                const re = SDIConstants.numberRegEX;
                let val = e.target.value;
                Precision = val;
                let decPoints = "";
                let decArray = [];
                let pointCount = 0;
                this.setState({ unitPriceErrorMsg: "" });

                if (val.includes(".")) {
                    decArray = val.split(".");
                    decPoints = decArray[1];
                    Precision = decArray[0];
                }
                if (Precision.length <= 10) {
                    if ((e.target.value === '' || re.test(e.target.value)) && (decPoints.length <= 2 || decArray.length == 0)) {
                        if (e.target.value === '') {
                            this.setState({ EstPrice: val, ExtPrice: 0 });
                        }
                        else {
                            let locExtPrice;
                            if (this.state.quantity != "") {
                                locExtPrice = parseInt(this.state.quantity) * e.target.value
                                locExtPrice = parseFloat(locExtPrice.toFixed(2))
                            }
                            this.setState({ EstPrice: val, ExtPrice: locExtPrice });
                        }

                    }

                }

            }
            else {
                return;
            }
        }
    }
    onChangeSupplier = (event) => {
        this.setState({ SupplierValue: event.target.value });
    }
    onChangeCatItem = (type) => {
        let locYes, locNo;
        if (type == "Y") {
            locYes = true;
            locNo = false;
        }
        else {
            locYes = false;
            locNo = true;
        }
        this.setState({ CatYes: locYes, CatNo: locNo });
    };
    handleMfgName = (event) => {
        //WW-981 To handle 3rd char type ahead - Deepthi N H
        if (event.target.value.length <= 30) {
            if (event.target.value.length == 3) {
                if (this.state.mfgName.length == 2) {
                    MFGSearchValue = event.target.value;
                    let MFGNameBO = {
                        Entered_MFGName: event.target.value
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    SrcNonCatalogAction.GetMfgNameSuggestions(MFGNameBO)
                }
                else {
                    let MFGResult = this.state.MFGAllSuggestions.filter((item) => item.label.toUpperCase().includes(event.target.value.toUpperCase()));
                    this.setState({ mfgName: event.target.value, MFGSuggestions: MFGResult });
                }
            }
            else if (event.target.value.length > 3) {
                let MFGResult = this.state.MFGAllSuggestions.filter((item) => item.label.toUpperCase().includes(event.target.value.toUpperCase()));
                this.setState({ mfgName: event.target.value, MFGSuggestions: MFGResult });
            }
            else {
                this.setState({ mfgName: event.target.value, MFGSuggestions: [] });
            }
        }

    }
    /**
     * Handle method for all form input controls
     */
    handleChange = (event) => {
        $("#quickItemSuccess").hide();
        //  alert("handlechagne")
        this.setState({ [event.target.name]: event.target.value });
    };
    /**
     * Click method for cancel button
     */
    cancelClick = () => {
        this.props.history.push({
            pathname: "/HomePage",
        });
    };
    OkClick = (e) => {
        $(`#SuccessPopUp`).hide();
    }

    handleEquipmentYes = () => {
        $('#SrcMixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        this.saveNonCatalog(this.state.pendingSaveType);
    };

    handleEquipmentNo = () => {
        $('#SrcMixedOrderConfirmPopup').modal('hide');
        cartDelete = false;
    };

    /**
     * Ref:NC_PC_11
     * Click method for Save and Save/More buttons
     * @param saveType
     */
    saveNonCatalog = (saveType) => {

        $(`#nonCatalogSaveSuccess`).hide();
        $(`#SuccessPopUp`).hide();
        this.setState({ isbuttonclick: true });
        if (!this.state.mfgPartNumber || !this.state.mfgName || !this.state.quantity || !this.state.description || !this.state.uom ||
            !this.state.supplierPrtNbr || !this.state.SupplierValue || this.state.SupplierValue == "0" || !this.state.EstPrice || !this.state.DeliveryDate || this.state.attachmentPathArr.length == 0) {
            //WW-981 to make attachment as mandatory - Deepthi N H
            if (this.state.attachmentPathArr.length == 0) {
                this.setState({ isInvalid: true, attachmentErrormsg: "Please upload attachment" });
            }
            this.setState({ isInvalid: true, qtyErrorMsg: !this.state.quantity ? "Please enter quantity" : "", unitPriceErrorMsg: !this.state.EstPrice ? "Please enter unit price" : "" });


            return false
        }
        {/*[07/21/2022PC_01 WAL-819 ISSUE] Pavithra R*/ }
        if (parseInt(this.state.quantity) == 0 || this.state.quantity == "") {
            //this.setState({ isInvalid: true });
            //swal({
            //    allowOutsideClick: false,
            //    closeOnClickOutside: false,
            //    text: "Please enter a valid Quantity"
            //});
            // alert("Please enter a valid Quantity")
            this.setState({ qtyErrorMsg: "Please enter a valid Quantity" })
            return false
        }


        let attachmentStr = "";
        //let testattachment = "https://alexcorvi.github.io/heic2any/demo/14.heic";
        if (this.state.attachmentPathArr.length > 0) {
            attachmentStr = this.state.attachmentPathArr.map(e => e.FilePath).join("|");
            if (attachmentStr.length > 254) {
                this.setState({
                    attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                });
                return false;
            }

        }
        else {
            this.setState({
                attachmentErrormsg: "Please upload attachment"
            });
        }
        let SrcType;
        if (this.state.CatYes) {
            SrcType = "WCAT";
        }
        else {
            SrcType = "WNST";
        }
        let DelDate = this.state.DeliveryDate;
        let ValidDelDate = this.handledate(DelDate);
        let Price = this.state.EstPrice;
        if (Price != "") {
            if (Price.includes(".")) {
                let decArray = Price.split(".");
                let decPoints = decArray[1];
                let Precision = decArray[0];
                if ((decPoints == "00" && parseInt(Precision) == 0) || (parseInt(decPoints) == 0 && parseInt(Precision) == 0)) {
                    this.setState({ unitPriceErrorMsg: "Please enter a valid unit price" })
                    return false
                }
            }
            else if (parseInt(Price) == 0 || Price == "") {
                this.setState({ unitPriceErrorMsg: "Please enter a valid unit price" })
                return false
            }
        }
        Price = Number(Price).toFixed(2)
        //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            let hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            let hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
            if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
                $('#SrcMixedOrderConfirmPopup').modal('show');
                this.setState({ pendingSaveType: saveType, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
            else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
                $('#SrcMixedOrderConfirmPopup').modal('show');
                this.setState({ pendingSaveType: saveType, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
        }

        let savenonCatalogBO = {
            txtSuppPartNum: this.state.supplierPrtNbr.trim(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_PUNCHIN: CookieService.getLocalStorageValues("Session_PUNCHIN"),
            txtEstPrice: Price,
            txtDesc: this.state.description.trim(),
            txtMfgPartNum: this.state.mfgPartNumber.trim(),
            txtMfgName: this.state.mfgName.trim(),
            txtQty: this.state.quantity,
            DropUOM: this.state.uom,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            filePath: attachmentStr,
            Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
            VendorId: this.state.SupplierValue,
            DueDate: ValidDelDate,
            IsSrcNonCatalog: true,
            PaintColor: SrcType,
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            EquipmentDelete: cartDelete,
            Interactive: false
        };
        this.setState({ isInvalid: false });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SrcNonCatalogAction.saveNonCatalog(savenonCatalogBO);
        this.setState({ MFGSuggestions: [], MFGAllSuggestions: [] });
        type = saveType;
    };


    /**
     * Ref:NC_PC_20
     * Render method to bind the controls
     */
    render() {
        const { t } = this.props;
        return (
            <div className="container-fluid content-section">
                <div className="row">
                    <div className="container-fluid content-margin">
                        <div className="row non-catalog-req-form">
                            <div className="col-md-12 page-heading mb-3">
                                <h5 className="page-title"><Trans>Sourced Non-Catalog Entry</Trans></h5>
                                <span className="info-container float-left ml-2">
                                    <img className=" mr-2 mt-3 float-left" src="Images/info-icon.png" />
                                    <span className="Grid-info-icon3 text-left sdi-fede-tooltippickup ">This source non-catalog item will not be persistent across platforms. Please add and place this item on the website.</span>
                                </span>
                                <div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-1">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>
                            </div>
                            {/*<div className="col-md-12 form-container">
                                <span className="float-right indicate-alert"><Trans>Required_key</Trans></span>
                            </div>*/}
                            <div className="col-md-12 mt-4">
                                <div className="row">
                                    <div className="col-md-4 mb-3 block-container">
                                        <label className="form-label catalog-label" htmlFor="manufacturer-name">Manufacturer name<span className="color-manditory">*</span></label>
                                        <Autocomplete
                                            getItemValue={this.getItemValue}
                                            items={this.state.MFGSuggestions}
                                            renderItem={this.renderItem}
                                            value={this.state.mfgName}
                                            onChange={this.handleMfgName}
                                            maxLength="30"
                                            onSelect={(e) => this.onSelectItem(e)}
                                            name="mfgName"
                                            inputProps={{ placeholder: "Enter manufacturer name", className: "form-control rounded", width: "246px" }}
                                            menuStyle={{ fontSize: '80%', position: 'absolute', maxHeight: '200px', overflow: 'auto', borderRadius: '3px', zIndex: '9999', top: '80px', left: '15px', boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)', }}
                                        />
                                        {this.state.isInvalid && this.state.mfgName == "" ? <span className="font-12 font-regular color-validation">Please enter manufacturer name</span> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="manufacturer-part">Manufacturer part # <span className="color-manditory">*</span></label>
                                        <input type="text" className="form-control rounded" name="mfgPartNumber" maxLength="50" value={this.state.mfgPartNumber} onChange={this.handleChange} placeholder="Enter manufacturer part #" id="manufacturer-part" />
                                        {this.state.isInvalid && this.state.mfgPartNumber == "" ? <span className="font-12 font-regular color-validation">Please enter manufacturer part #</span> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="supplier">Supplier<span className="color-manditory">*</span></label>
                                        <select className="form-control" id="supplier" name="SupplierValue" value={this.state.SupplierValue} onChange={this.onChangeSupplier}>
                                            {this.bindSupplierDropdown()}
                                        </select>
                                        {this.state.isInvalid && (this.state.SupplierValue == "" || this.state.SupplierValue == "0") ? <span className="font-12 font-regular color-validation">Please select supplier</span> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="manufacturer-name">Supplier part #<span className="color-manditory">*</span></label>
                                        <input type="text" className="form-control rounded" placeholder="Enter supplier part #" maxLength="100" placeholder="Enter Value" name="supplierPrtNbr" value={this.state.supplierPrtNbr} onChange={this.handleChange} />
                                        {this.state.isInvalid && this.state.supplierPrtNbr == "" ? <span className="font-12 font-regular color-validation">Please enter supplier part #</span> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label w-100" htmlFor="extended">Catalog item</label>
                                        <label className="custom-radiobtn mr-2 my-2">Yes
                                        <input type="radio" name="radio" checked={this.state.CatYes} id="yesId" onChange={() => this.onChangeCatItem("Y")} />
                                            <span className="checkmark" />
                                        </label>
                                        <label className="custom-radiobtn mr-2 my-2">No
                                        <input type="radio" checked={this.state.CatNo} id="noId" onChange={() => this.onChangeCatItem("N")} />
                                            <span className="checkmark" />
                                        </label>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="delivery-date">Delivery date<span className="color-manditory">*</span></label>
                                        {/*<input type="date" className="form-control rounded" id="delivery-date" />*/}
                                        <div className="d-inline-block col-md-12 p-0 OLDatepicker" id="OLDueDateDiv">
                                            <DatePicker className="form-control rounded"
                                                id="OLDueDate"
                                                fixedHeight
                                                placeholderText="MM/DD/YYYY"
                                                dateFormat="MM/dd/yyyy"
                                                showMonthDropdown
                                                showYearDropdown
                                                minDate={new Date()}
                                                selected={this.state.DeliveryDate}
                                                onChange={(e) => this.onChangeText("Date", e)}
                                            />
                                            <span className="calendar-icon filter-calendar-icon " onClick={() => $(`#OLDueDate`).focus()} />

                                        </div>
                                        {this.state.isInvalid && this.state.DeliveryDate == "" ? <span className="font-12 font-regular color-validation">Please select delivery date</span> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="unit-price">Unit price<span className="color-manditory">*</span></label>
                                        <input type="text" className="form-control rounded" placeholder="Enter unit price" name="EstPrice" value={this.state.EstPrice} onChange={(e) => this.onChangeText("Price", e)} />
                                        {(this.state.isInvalid && this.state.EstPrice == "") || this.state.unitPriceErrorMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.unitPriceErrorMsg}</span> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="quantity">Quantity<span className="color-manditory">*</span></label>
                                        <input type="text" className="form-control rounded" placeholder="Enter quantity" id="quantity" maxLength="5" name="quantity" value={this.state.quantity} onChange={this.handleQuantity} />
                                        {(this.state.isInvalid && this.state.quantity == "") || this.state.qtyErrorMsg != "" ? <span className="font-12 font-regular color-validation">{this.state.qtyErrorMsg}</span> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="extended">Extended price</label>
                                        <input type="text" className="form-control rounded" disabled id="extended" defaultValue={0} value={this.state.ExtPrice} />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label" htmlFor="uom">Unit of measure</label>
                                        <select className="form-control" id="uom" name="uom" value={this.state.uom} onChange={this.handleChange}>
                                            {this.bindUOMDropdown()}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label catalog-label w-100">Attachment<span className="color-manditory">*</span>
                                            {/*<span className="info-container ml-2">
                                                <img className=" mr-2 " src="Images/info-icon.png" />
                                                <span className="Grid-info-icon3 text-left sdi-fede-tooltippickup ">Please upload a file with size less than 3MB</span>
                                            </span>*/}
                                        </label>
                                        <div className="w-100 d-flex flex-wrap">
                                            <span className="browse-btn mr-3 mb-2">
                                                <button type="button" className="font-medium font-14 btn btn-primary custom-btn-primary primary-btn"><img src="images/upload-icon.svg" alt="upload" className="mr-1" /> Upload</button>
                                                <input type="file" name="myfile" placeholder="Choose File" accept="application/pdf, image/jpeg, image/png, message/rfc822, application/vnd.ms-outlook" id="srcFileInput" name="filename" onChange={this.handleAttachment} onClick={this.handleFileOnClick} />
                                            </span>
                                            {this.bindAttachments()}


                                        </div>
                                        {this.state.attachmentErrormsg != "" ? <span className="font-12 font-regular color-validation">{this.state.attachmentErrormsg}</span> : null}
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label catalog-label" htmlFor="description">Description<span className="color-manditory">*</span></label>
                                        <textarea className="form-control rounded" id="description" placeholder="Enter Description" rows={3} defaultValue={""} maxLength="254" name="description" value={this.state.description} onChange={this.handleChange} />
                                        {this.state.isInvalid && this.state.description == "" ? <span className="font-12 font-regular color-validation">Please enter description</span> : null}
                                    </div>
                                    <div className="col-md-12 mb-3 my-5">
                                        <div className="d-grid d-md-flex justify-content-md-end align-items-center grid-resp-style">
                                            <button className="btn btn-dark-grey font-14 font-medium mr-2 px-4 py-2 resp-marginright-0" onMouseDown={this.cancelClick}>Cancel</button>
                                            <button className="btn btn-light-grey font-14 font-medium mr-2 px-4 py-2 resp-marginright-0" onMouseDown={e => this.clearFormValues()}>Clear</button>
                                            <button className="btn btn-custom-primary font-14 font-medium mr-2 px-4 py-2 resp-marginright-0" onMouseDown={() => this.saveNonCatalog(1)}>Save/More</button>
                                            <button className="btn btn-custom-primary font-14 font-medium px-4 py-2" onMouseDown={() => this.saveNonCatalog(2)}>Save/Done</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <span className="float-left err-msg text-danger col-md-12 text-center bold mb-3" id="nonCatalogSaveSuccess"><Trans>Itemaddedtocart_key</Trans></span>*/}
                            {/*<p className="NC-helptext col-md-12 float-left my-5"><span>** </span><Trans> Non-Catalog Orders require an additional process and you will be notified via email when your quote is available. At which point you will need to come back to this catalog to approve for final procession.</Trans>
                                <span>**</span></p>*/}
                        </div>
                    </div>
                </div>
                <div className="modal" id="SuccessPopUp" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content py-2">
                            {/*Success Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/tick.svg" alt="tick" />
                                        <p className="mb-1 font-14 font-regular color-light-black">Item added to the cart successfully!</p>
                                    </div>
                                </div>
                            </div>
                            {/*Success end here*/}
                            {/*button*/}
                            <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={(e) => this.OkClick(e)}>OK</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>

                {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
                <div className="modal fade p-0" id="SrcMixedOrderConfirmPopup" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Confirmation
                                    </h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                {this.state.cartConfirmationPopupTxt}
                            </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4"
                                    type="button"
                                    data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  >No</button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                    type="button">Yes</button>

                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}

            </div>);

    };
}
export default withTranslation()(NonCatalogComponent);

